/**
 * Created by Zhonghua on 15/11/2016.
 */

export class ErrorProcessor {
  public static processError(message: string, error: any) {}
}
